<script>
import { required, numeric } from "vuelidate/lib/validators";
// import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import Swal from "sweetalert2";
import id from "vue2-datepicker/locale/es/id";
// import Multiselect from "vue-multiselect";

export default {
  props:['id','name','products'],
  // components: { Multiselect, validationMessages },
  validations:{
    selectedProducts: { required },
  },
  data() {
    return {
      brand_name: "",
      showModal: false,
      submitted: false,
      isBusy: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      campaignGUID: '',
      campaignName:'',
      productData:[],
      parentProducts:[],
      productIds: [],
      selectedProducts:"",
      showSubmit: false,
      totalRows: 0,
      currentPage: 1,
      fileText: 'Upload CSV File',
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "created_on",
      tableData: [],
      sortDesc: true,
      fields: [

        {
          key: "Art_ID",
          label: "Product ID",
          sortable: true,
        },

        {
          key: "Art_Ime",
          label: "Product Name",
          sortable: true,
        },

        "action"
      ],


    };
  },
  computed:{
    filteredProducts(){
      if(!this.productData || this.productData.length === 0){
        return this.parentProducts
      }

      const linkedProducts = this.productData.map(prod =>
          prod.prod_id
      )

      return this.parentProducts.filter(product => !linkedProducts.includes(product.Art_ID))
    }
  },

  methods: {

    async submitForm() {
      this.tryingToSubmit = true;

      // if (this.$v.$invalid) {
      //   this.submitted = true;
      //   this.tryingToSubmit = false;
      //   return;
      // }
      // const product_ids = this.selectedProducts.map(products => products.Art_ID);
      this.showLoader = true;
      const data = {
        campaign_guid: this.campaignGUID,
        prod_id: this.productIds,
      }
      try {
        const response = await Merchandising.addCampaignProduct(data);
        if (response.success === false) {
          Swal.fire("Error", response.error || "Failed to link products. Please try again.", "error");
        } else {
          Swal.fire("Success", "Products successfully linked!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to link products:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to link products. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },

    async unlinkProduct(prod_id,campaign_guid) {
      Swal.fire({
        title: "Remove Product?",
        text: "This Product will be removed from this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.removeCampaignProduct(prod_id,campaign_guid);
            if (response.data) {
              Swal.fire("Success!", "Product is successfully removed!", "success");
              await this.getCampaignProducts();
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while removing product!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });
    },

    async removeAllProducts(campaign_guid) {
      Swal.fire({
        title: "Remove All Product?",
        text: "All Products will be removed from this Campaign!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await Merchandising.removeAllCampaignProduct(campaign_guid);
            if (response.data) {
              Swal.fire("Success!", "Products  successfully removed!", "success");
              await this.getCampaignProducts();
            } else {
              let errorMessage = response.error ? response.error : 'Failed';
              if (typeof errorMessage === 'object') {
                errorMessage = errorMessage[0];
              }
              Swal.fire("Fail!", errorMessage, "warning");
            }
          } catch (error) {
            let errorMessage = error.response && error.response.data && error.response.data.error
                ? error.response.data.error
                : "An error occurred while removing products!";
            if (typeof errorMessage === 'object') {
              errorMessage = errorMessage[0];
            }
            Swal.fire("Error", errorMessage, "error");
          }
        }
      });
    },

    resetForm() {
      this.$v.$reset();
      this.selectedProducts= ""
      this.parentProducts= []
      this.selectedProducts = [];
      this.tableData = [];
      this.totalRows = 0;
      this.currentPage = 1;
      this.perPage = 10;
      this.filter = null;
      this.filterOn = [];
      this.sortBy = "created_on";
      this.sortDesc = true;
      this.fileText = 'Upload CSV File';
      this.showSubmit = false;


    },
    customLabel(option) {
      return `${option.Art_Ime} - ${option.Art_ID}`;
    },


    closeModal() {
      this.resetForm();
      this.showModal = false;
    },

    async getCampaignProducts(){
      try {
        this.isBusy = true;
        const response = await Merchandising.getCampaignProducts(this.campaignGUID);
        this.productData = response.data.data.products;
        this.tableData = this.productData;
        this.totalRows = this.productData.length;
        // this.parentProducts = this.products;
      }catch (error){
        console.error(error);
        this.isBusy = false;
      }finally {
        this.isBusy = false;
      }
    },

    triggerFile() {
      this.$refs.fileInput.click();
    },
    handleFile(event) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = (e) => {
        const csvText = reader.result;

        const rows = csvText.split("\n").map(r => r.trim());
        const parsed = rows.map(row => row.split(","));


        const firstRow = parsed[0];

        const isHeader =
            firstRow.every(col => isNaN(col)) ||
            firstRow.some(col => col.includes("_"));
        if(isHeader){
          for(let i=1;i<parsed.length;i++){
            this.productIds.push(parsed[i][0]);
          }
        }else{
          for(let i=0;i<parsed.length;i++){
            this.productIds.push(parsed[i][0]);
          }
        }

      }
      reader.readAsText(file);

      if (file) {
        this.fileText = file.name;
        this.showSubmit = true;
      }
    },



    refreshData() {
      this.$emit("onRefresh");
    },
    async syncData(){
      this.campaignGUID = this.id;
      this.campaignName = this.name;
      await this.getCampaignProducts();
    }

  },


};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="link_products_to_campaign"
      size="xl"
      v-model="showModal"
      title="Link Products To Campaign"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">

        <div class="row" >
<!--          <div id="right_side" class="col-6">-->
<!--            <h5>Campaign: {{campaignName}}</h5>-->
<!--            <h5 style="margin-bottom:40px;">Total Linked Products: {{totalRows}}</h5>-->

<!--            <b-form-group>-->
<!--              <label class="typo__label" for="ajax">Products</label>-->
<!--              <multiselect v-model="selectedProducts"-->
<!--                           :custom-label="customLabel"-->
<!--                           track-by="Art_ID"-->
<!--                           placeholder="Type to search products"-->
<!--                           :multiple="true"-->
<!--                           :options="filteredProducts"-->
<!--                           :searchable="true"-->
<!--                           :loading="showLoader"-->
<!--                           :internal-search="true"-->
<!--                           :clear-on-select="false"-->
<!--                           :close-on-select="false"-->
<!--                           :options-limit="300"-->
<!--                           :max-height="600"-->
<!--                           :show-no-results="false"-->
<!--                           :hide-selected="true"-->
<!--                           :class="{ 'is-invalid': submitted && $v.selectedProducts.$error }">-->

<!--                <template slot="tag" slot-scope="{ option, remove }">-->
<!--                  <span class="custom__tag">-->
<!--                      <span>{{ option.Art_Ime }} - {{option.Art_ID}}</span>-->
<!--                      <span class="custom__remove" @click="remove(option)">✖</span>-->
<!--                  </span>-->
<!--                </template>-->
<!--              </multiselect>-->
<!--              <validationMessages v-if="submitted" :fieldName="'Selected Product'" :validationName="$v.selectedProducts"></validationMessages>-->

<!--            </b-form-group>-->
<!--          </div>-->
          <div id="left_side" class="col-12">
            <h5 class="text-center">Linked Products To Campaign {{campaignName}}</h5>
            <h5 style="margin-bottom:40px;">Total Linked Products: {{totalRows}}</h5>
            <!-- Search -->
            <div class="col-sm-12 col-md-12 row">
              <div  class="col-6 text-md-start d-flex align-items-center gap-3">
                <div class="custom-file-upload" @click="triggerFile">
                  <span>{{ fileText }}</span>
                </div>

                <input
                    ref="fileInput"
                    type="file"
                    accept=".csv"
                    class="hidden-input"
                    @change="handleFile"
                />
                <b-button v-if="showSubmit" variant="primary" @click="submitForm" :disabled="!showSubmit">
                  <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
                </b-button>
                <button v-if="tableData.length" class="btn btn-danger" @click="removeAllProducts(campaignGUID)">Remove All Products</button>
              </div>
              <div
                  id="campaign-products-table_filter"
                  class="dataTables_filter col-6 d-flex justify-content-end align-items-center"
              >
                <label class=" mb-0 d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="tableData"
                  :busy="isBusy"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
              >


                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(action)="data">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <a href="javascript:void(0);" @click="unlinkProduct(data.item.Art_ID,data.item.campaign_guid)"  title="Remove Product">
                        <i class="uil uil-trash-alt text-danger font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>


            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
    </template>
  </b-modal>
</template>

<style>
.hidden-input {
  display: none;
}

.custom-file-upload {
  padding: 10px 13px;
  background: #34c38f;
  color: white;
  border-radius: 3px;
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
}


</style>
